/** @jsx  jsx */
import { css } from '@emotion/core';
import { MediaQueries } from '../../../styles/Grid';

export const spacerMarginCss = css({
  marginTop: 24,
  marginBottom: 64,
  [MediaQueries.md]: {
    marginTop: 56,
    marginBottom: 96,
  },
  [MediaQueries.lg]: {
    marginTop: 56,
    marginBottom: 96,
  },
  [MediaQueries.xl]: {
    marginTop: 65,
    marginBottom: 96,
  },
});
export const spacerPaddingCss = css({
  paddingTop: 24,
  paddingBottom: 64,
  [MediaQueries.md]: {
    paddingTop: 56,
    paddingBottom: 96,
  },
  [MediaQueries.lg]: {
    paddingTop: 56,
    paddingBottom: 96,
  },
  [MediaQueries.xl]: {
    paddingTop: 65,
    paddingBottom: 96,
  },
});
